module.exports = __webpack_public_path__ + "img/login-logo.7bfae082.png";